/**
 * Error that is thrown when a something has gone wrong trying to delete an asset
 */
export class DeleteFailedError extends Error {
    constructor(message) {
        super(message);
        this.name = 'DeleteFailedError';
    }
}
//# sourceMappingURL=DeleteFailedError.js.map